import { render, staticRenderFns } from "./SpacingComplex.vue?vue&type=template&id=e798cc2a&"
import script from "./SpacingComplex.vue?vue&type=script&lang=ts&"
export * from "./SpacingComplex.vue?vue&type=script&lang=ts&"
import style0 from "./SpacingComplex.vue?vue&type=style&index=0&id=e798cc2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports